import { useMemo } from 'react'

import { Alert } from '@vtex/shoreline'

import Panel from '~/components/Panel'
import { Badge } from '~/components/UI/Badge'
import { Label } from '~/components/unform'
import { useAPPTranslation } from '~/i18n/useAPPTranslation'

const TotalBudgetView: BudgetComponent = ({
  Title,
  values,
  totalBudget,
  isTemporaryValidationID = false
}) => {
  const { t } = useAPPTranslation()
  const hasTotalBudget = !!totalBudget
  const hasTotalCost = !!values.totalCost

  const totalCostContent = useMemo(() => {
    if (hasTotalBudget) {
      return totalBudget
    }
    if (hasTotalCost) {
      return values.totalCost
    }
    return <Badge template="warning">{t('rm:pending')}</Badge>
  }, [hasTotalBudget, hasTotalCost, totalBudget, values.totalCost, t])

  {
    hasTotalBudget ? (
      totalBudget
    ) : hasTotalCost ? (
      values.totalCost
    ) : (
      <Badge template="warning">{t('rm:pending')}</Badge>
    )
  }

  return (
    <Panel
      data-investment-budget="totalBudget-view"
      title={Title}
      description={t('rm:campaign.create.Investment.description')}
    >
      <section className="d-flex gap-3">
        <div className="pe-3 border-end">
          <Label text={t('rm:campaign.create.Investment.duration.title')} />
          <span>
            {values.duration ? (
              t('rm:campaign.create.Investment.duration', {
                duration: values.duration
              })
            ) : (
              <Badge template="warning">
                {t('rm:campaign.create.Investment.duration.placeholder')}
              </Badge>
            )}
          </span>
        </div>

        <div className="span-start pe-3 border-end">
          <Label text={t('rm:campaign.create.Investment.places.title')} />
          <span>
            {values.totalPlaces || (
              <Badge template="warning">
                {t('rm:campaign.create.Investment.places.placeholder')}
              </Badge>
            )}
          </span>
        </div>

        {!isTemporaryValidationID && !hasTotalBudget && (
          <div className="pe-3 border-end">
            <Label text={t('rm:campaign.create.Investment.dailyCost.title')} />
            <span>
              {values.totalDailyCost || (
                <Badge template="warning">{t('rm:pending')}</Badge>
              )}
            </span>
          </div>
        )}

        <div>
          <Label text={t('rm:campaign.create.Investment.totalCost.title')} />
          <span>{totalCostContent}</span>
        </div>
      </section>

      {!hasTotalBudget && (
        <footer className="mt-3">
          <Alert variant="informational">
            {t('rm:campaign.create.Investment.info.dailyCost')}
          </Alert>
        </footer>
      )}
    </Panel>
  )
}

export default TotalBudgetView
